import { isEmptyObject } from "../../../utils/isEmptyObject";

export const storeGameList = (data) => {
  return {
    type: "storeGameList",
    payload: data,
  };
};
export const storeGameLink = (link) => {
  return {
    type: "storeGameLink",
    payload: link,
  };
};
export const openGame = () => {
  return {
    type: "openGame",
  };
};
export const closeGame = () => {
  return {
    type: "closeGame",
  };
};
export const openFullScreen = () => {
  return {
    type: "openFullScreen",
  };
};
export const closeFullScreen = () => {
  return {
    type: "closeFullScreen",
  };
};

export const filterGameList = ({
  allGameList,
  allGamePlatform,
  allGameType,
  allGame_subtype,
  allNewGameList = [],
  allTopGameList = [],
  randomlySelectedGames = [],
  userFavoriteGame = {},
  exclusiveBrandGames = [],
}) => {
  // 全部遊戲
  const ALLGAMES = Object?.values(allGameList || {})?.flat();

  //所有遊戲平台
  const allPlatform = allGamePlatform?.map((item) => {
    return item.platform;
  });

  //所有遊戲種類
  const allType = allGameType?.map((item) => {
    return item.gameTypeName;
  });

  //所有遊戲
  const constructGameList = (types, platforms) => {
    return types?.reduce((acc, type) => {
      const gameTypeCode = allGameType.find(
        (t) => t.gameTypeName === type
      )?.gameTypeUid;
      const platformData = platforms?.reduce((subAcc, platform) => {
        const platformCode = allGamePlatform.find(
          (p) => p.platform === platform
        )?.platformUid;
        const platformTypeGame = allGameList[gameTypeCode]?.filter(
          (game) => game.platformUid === platformCode
        );
        return platformTypeGame?.length
          ? { ...subAcc, [platform]: platformTypeGame }
          : subAcc;
      }, {});
      return isEmptyObject(platformData)
        ? acc
        : { ...acc, [type]: platformData };
    }, {});
  };

  const gameList = constructGameList(allType, allPlatform);

  const categorizedGames = ALLGAMES?.reduce((acc, game) => {
    const subType = allGame_subtype?.map((item) => item.game_subtype);
    subType.forEach((type) => {
      acc[type] = acc[type] || [];
    });

    if (subType.includes(game.game_subtype)) {
      acc[game.game_subtype].push(game);
    }

    return acc;
  }, {});

  const gamePlatformSortGames = () => {
    const objectValues = Object.values(gameList || {});
    return objectValues.reduce((acc, cur) => {
      Object.entries(cur).forEach(([key, value]) => {
        if (!acc[key]) {
          acc[key] = value;
        } else {
          acc[key] = [...acc[key], ...value];
        }
      });

      return acc;
    }, {});
  };

  const platformAndCategory = () => {
    const result = {};
    const platformGames = gamePlatformSortGames();
    for (const [key, array] of Object.entries(platformGames)) {
      result[key] = {};

      for (const item of array) {
        const type = item.game_subtype;
        if (!result[key][type]) {
          result[key][type] = [];
        }
        result[key][type].push(item);
      }
    }
    return result;
  };

  const favoriteGameList = Object.values(userFavoriteGame || {}).flat();

  return {
    type: "filterGameList",
    payload: {
      allGames: ALLGAMES,
      gameList: gameList,
      platform: allPlatform,
      gameType: allType,
      allGamePlatform: allGamePlatform,
      game_subtype: allGame_subtype,
      newGameList: allNewGameList,
      topGameList: allTopGameList,
      categorizedGames: { ...categorizedGames, MyFavorite: favoriteGameList },
      randomlySelectedGames: randomlySelectedGames,
      sortedByPlatformGames: gamePlatformSortGames(),
      sortedByPlatformAndCategoryGames: platformAndCategory(),
      favoriteGameList: favoriteGameList,
      exclusiveBrandGames: exclusiveBrandGames,
    },
  };
};
export const openVipBar = () => {
  return {
    type: "openVipBar",
  };
};

export const closeVipBar = () => {
  return {
    type: "closeVipBar",
  };
};

export const openAccessTool = () => {
  return {
    type: "openAccessTool",
  };
};

export const closeAccessTool = () => {
  return {
    type: "closeAccessTool",
  };
};

export const storeGameConfig = (data) => {
  return {
    type: "storeGameConfig",
    payload: data,
  };
};
export const clearGameConfig = () => {
  return {
    type: "clearGameConfig",
  };
};

export const storeFavoriteGameList = (data) => {
  return {
    type: "storeFavoriteGameList",
    payload: Object.values(data || {}).flat(),
  };
};

export const clearFavoriteGameList = () => {
  return {
    type: "clearFavoriteGameList",
  };
};

export const clearGameLink = () => {
  return {
    type: "clearGameLink",
  };
};

export const triggerGame = () => {
  return {
    type: "triggerGame",
  };
};

export const startGameLoading = () => {
  return {
    type: "startGameLoading",
  };
};
export const endGameLoading = () => {
  return {
    type: "endGameLoading",
  };
};
